module.exports = __webpack_public_path__ + "img/btn_set_test.d9c3a59e.png";